let $ = jQuery;

export function customScriptPluginMember() {
    $('body').on('click', closeDropdownProfileEdit)
}

function closeDropdownProfileEdit() {
    $('.um-profile-headericon .um-profile-edit-a').removeClass('active');
    $('.um-dropdown').hide();
}